import {
  getCallToActionsQueryOptions,
  getCallToActionQueryOptions,
  getCallToActionsByAdPlatformQueryOptions
} from "../../queries/callToActions";
import { getAdPlatformsQueryOptions } from "../../queries/adPlatforms";

// necessary entities are pre-fetched when a user hover a 'create callToAction' or a 'edit callToAction' link
export const callToActionFormLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getAdPlatformsQueryOptions());
};

// callToActions are pre-fetched when a user hover a 'callToActions' link
export const callToActionListLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getCallToActionsQueryOptions());
};

// callToActions are pre-fetched when a user hover a 'callToActions' link within a adPlatform
export const callToActionListByAdPlatformLoader = ({
  params,
  context: { queryClient },
}) => {
  const { adPlatformId } = params;
  queryClient.ensureQueryData(
    getCallToActionsByAdPlatformQueryOptions(adPlatformId, queryClient)
  );
};

// callToAction is pre-fetched when a user hover a 'view callToAction' link
export const callToActionViewLoader = ({ params, context: { queryClient } }) => {
  const { callToActionId } = params;
  queryClient.ensureQueryData(getCallToActionQueryOptions(callToActionId, queryClient));
};
